import { Component } from '@angular/core';

@Component({
  selector: 'atlas-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss'],
  standalone: false,
})
export class ModalContentComponent {}
